<template>
  <div class="typography-section">
    <WeatherBackground />
    <div class="animated-weather-elements">
      <div class="cloud cloud-1"></div>
      <div class="cloud cloud-2"></div>
      <div class="wind-gust wind-1"></div>
      <div class="wind-gust wind-2"></div>
      <div class="storm-indicator"></div>
    </div>
    <BrandHero />
  </div>
</template>

<script>
import WeatherBackground from "./WeatherBackground.vue";
import BrandHero from "./BrandHero.vue";

export default {
  name: "LeftSection",
  components: {
    WeatherBackground,
    BrandHero,
  },
};
</script>

<style scoped>
.typography-section {
  flex: 0 0 60%;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  height: 100vh;
}

.animated-weather-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  overflow: hidden;
  pointer-events: none;
}

.cloud {
  position: absolute;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 100px;
  z-index: 3;
  box-shadow: inset -20px -20px 40px rgba(0, 0, 0, 0.2);
}

.cloud::before,
.cloud::after {
  content: "";
  position: absolute;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 100px;
}

.cloud-1 {
  width: 250px;
  height: 80px;
  top: 15%;
  left: -250px;
  animation: drift 25s infinite linear;
}

.cloud-1::before {
  width: 120px;
  height: 120px;
  top: -60px;
  left: 20px;
}

.cloud-1::after {
  width: 180px;
  height: 100px;
  top: -40px;
  right: 20px;
}

.cloud-2 {
  width: 200px;
  height: 70px;
  top: 40%;
  right: -200px;
  animation: drift-reverse 30s infinite linear;
  opacity: 0.6;
}

.cloud-2::before {
  width: 100px;
  height: 100px;
  top: -50px;
  left: 20px;
}

.cloud-2::after {
  width: 150px;
  height: 90px;
  top: -35px;
  right: 20px;
}

@keyframes drift {
  from {
    left: -250px;
  }
  to {
    left: 100%;
  }
}

@keyframes drift-reverse {
  from {
    right: -200px;
  }
  to {
    right: 100%;
  }
}

.wind-gust {
  position: absolute;
  height: 1px;
  background: linear-gradient(to right, rgba(100, 150, 255, 0.3), transparent);
  top: 50%;
  left: -150px;
  width: 300px;
  z-index: 3;
}

.wind-1 {
  top: 25%;
  animation: wind-blow 4s infinite ease-in-out;
}

.wind-2 {
  top: 65%;
  animation: wind-blow 5s 1.5s infinite ease-in-out;
  opacity: 0.5;
}

@keyframes wind-blow {
  0%,
  100% {
    left: -150px;
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  to {
    left: 100%;
  }
}

.storm-indicator {
  position: absolute;
  width: 300px;
  height: 300px;
  top: 20%;
  right: -100px;
  background: radial-gradient(
    circle,
    rgba(45, 219, 182, 0.1) 0%,
    transparent 70%
  );
  border-radius: 50%;
  z-index: 3;
  animation: storm-pulse 4s ease-in-out infinite;
}

@keyframes storm-pulse {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.1);
  }
}

@media (max-width: 1024px) {
  .typography-section {
    flex: 0 0 auto;
    height: auto;
    min-height: 40vh;
  }
}

@media (max-width: 480px) {
  .typography-section {
    display: none;
  }
}
</style>
